import { render } from "./DetailHeroSection.vue?vue&type=template&id=658d35d4&scoped=true"
import script from "./DetailHeroSection.vue?vue&type=script&lang=js"
export * from "./DetailHeroSection.vue?vue&type=script&lang=js"

import "./DetailHeroSection.vue?vue&type=style&index=0&id=658d35d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658d35d4"]])

export default __exports__